module.exports = __webpack_public_path__ + "static/media/black-square.74da46f6.svg";